import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';

export default class EarningsOversize extends BaseDangerDetail {
    constructor(props) {
        super(props);
    }

    getColumns = () => {
        return [{
            title: '',
            dataIndex: 'year'
        }, {
            title: '投资收益',
            dataIndex: 'investIncome'
        }, {
            title: '营业利润',
            dataIndex: 'profit'
        }];
    };
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialFraudAnalysis/subComponents/details/EarningsOversize.jsx